import { FormField } from '../../fields/formField';
import { SelectField } from '../../fields/selectField';
import { TextField } from '../../fields/textField';
import { FormGroup } from '../../formGroup';
import { WithOptional } from '../../utility';

type ConfigProps = WithOptional<
    ManufacturerAndModuleTypeFormGroup,
    keyof FormGroup
>;

export class ManufacturerAndModuleTypeFormGroup extends FormGroup {
    /** Data backing field for manufacturerText and manufacturerSelect */
    public readonly manufacturer: FormField<string>;
    public readonly manufacturerText: TextField;
    public readonly manufacturerSelect: SelectField<string>;
    /** Data backing field for moduleTypeText and moduleTypeSelect */
    public readonly moduleType: FormField<string>;
    public readonly moduleTypeText: TextField;
    public readonly moduleTypeSelect: SelectField<string>;

    public constructor(config: ConfigProps) {
        super(config);

        this.manufacturer = config.manufacturer;
        this.manufacturerText = config.manufacturerText;
        this.manufacturerSelect = config.manufacturerSelect;
        this.moduleType = config.moduleType;
        this.moduleTypeText = config.moduleTypeText;
        this.moduleTypeSelect = config.moduleTypeSelect;
    }
}
